import { ELLIPSIS } from "./ellipsis";
import {
    BuildWithBothLeftAndRightEllipsisParams,
    BuildWithLeftEllipsisParams,
    BuildWithRightEllipsisParams,
} from "./types";

export const buildArrayFromRange = (start: number, end: number) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, index) => index + start);
};

export const buildWithRightEllipsis = ({
    siblingCount,
    totalPages,
}: BuildWithRightEllipsisParams) => {
    const currentPageCount = 1;
    const leftAndRightSiblings = 2 * siblingCount;
    const firstAndLastBeforeEllipsisCount = 2;
    const leftItemCount =
        firstAndLastBeforeEllipsisCount +
        currentPageCount +
        leftAndRightSiblings;
    const leftRange = buildArrayFromRange(1, leftItemCount);

    return [...leftRange, ELLIPSIS, totalPages];
};

export const buildWithLeftEllipsis = ({
    siblingCount,
    totalPages,
    firstPageIndex,
}: BuildWithLeftEllipsisParams) => {
    const leftAndRightSiblings = 2 * siblingCount;
    const currentAndFinalPagesCount = 2;
    const intermediaryPageCountBetweenCurrentAndFinal = 1;
    const rightItemCount =
        currentAndFinalPagesCount +
        intermediaryPageCountBetweenCurrentAndFinal +
        leftAndRightSiblings;

    const rightRange = buildArrayFromRange(
        totalPages - rightItemCount + 1,
        totalPages
    );
    return [firstPageIndex, ELLIPSIS, ...rightRange];
};

export const buildWithBothLeftAndRightEllipsis = ({
    firstPageIndex,
    lastPageIndex,
    leftSiblingIndex,
    rightSiblingIndex,
}: BuildWithBothLeftAndRightEllipsisParams) => {
    const middleRange = buildArrayFromRange(
        leftSiblingIndex,
        rightSiblingIndex
    );
    return [firstPageIndex, ELLIPSIS, ...middleRange, ELLIPSIS, lastPageIndex];
};
